const MAX_QUANTITY = 99;
const {
  normalizedQuantity,
  pricingFor,
  compositionLabel,
  shopifyCartUpdates,
} = window.StorePricing;

const shopifyConfig = window.TellevoShopify || {};
const shopifyPrices = shopifyConfig.prices || { single: 3000, four: 10000 };

const packs = {
  single: { name: "Pack 1 sticker", price: "$3.000", quantity: 1 },
  four: { name: "Pack 4 stickers", price: "$10.000", quantity: 4 },
};

const cards = [...document.querySelectorAll(".pack-card")];
const drawer = document.querySelector("#cart-drawer");
const drawerPanel = drawer.querySelector(".cart-drawer__panel");
const drawerClose = drawer.querySelector(".cart-drawer__close");
const drawerBackdrop = drawer.querySelector(".cart-drawer__backdrop");
const quantityInput = document.querySelector("#cart-quantity");
const quantityMinus = document.querySelector("#quantity-minus");
const quantityPlus = document.querySelector("#quantity-plus");
const mobileName = document.querySelector("#mobile-pack-name");
const mobilePrice = document.querySelector("#mobile-pack-price");
const cartSubtotal = document.querySelector("#cart-subtotal");
const cartDiscount = document.querySelector("#cart-discount");
const discountRow = document.querySelector(".cart-summary__discount");
const cartTotal = document.querySelector("#cart-total");
const checkoutTotal = document.querySelector("#checkout-total");
const checkoutLabel = document.querySelector("#checkout-label");
const cartComposition = document.querySelector("#cart-composition");
const opportunityOptions = [...document.querySelectorAll("[data-opportunity-quantity]")];
const opportunityMessage = document.querySelector("#opportunity-message");
const checkoutButton = document.querySelector("#shopify-checkout");
const checkoutError = document.querySelector("#checkout-error");
const mobileBuy = document.querySelector(".mobile-buy");
const heroActions = document.querySelector(".emotional-hero .hero__actions");
const communityProgress = document.querySelector("[data-community-progress]");
const heroMobileVideo = document.querySelector("[data-hero-mobile-video]");

let selectedQuantity = 4;
let opener = null;
let analyticsQueue = [];
const attributionCapture = window.TellevoAttribution?.captureCurrent?.() || {
  attribution: null,
  captured: false,
};
const activeAttribution = attributionCapture.attribution;
const attributionAnalytics = window.TellevoAttribution?.analyticsContext?.(activeAttribution) || {};

function sendAnalyticsEvent(eventName, payload) {
  try {
    if (!window.Shopify?.analytics?.publish) return false;
    const publication = window.Shopify.analytics.publish(eventName, payload);
    publication?.catch?.(() => {});
    return true;
  } catch (_error) {
    return false;
  }
}

function publishAnalytics(eventName, data = {}) {
  const payload = {
    ...attributionAnalytics,
    ...data,
    page_path: window.location.pathname,
  };
  const fullName = `tellevo_${eventName}`;

  if (sendAnalyticsEvent(fullName, payload)) {
    analyticsQueue.forEach((queuedEvent) => {
      sendAnalyticsEvent(queuedEvent.eventName, queuedEvent.payload);
    });
    analyticsQueue = [];
    return;
  }

  if (analyticsQueue.length < 50) analyticsQueue.push({ eventName: fullName, payload });
}

if (attributionCapture.captured) {
  publishAnalytics("influencer_attributed", {
    landing_path: activeAttribution.landingPath,
    attribution_window_days: 30,
  });
}

function analyticsValue(quantity) {
  return pricingFor(quantity, shopifyPrices).total;
}

if (
  heroMobileVideo &&
  window.matchMedia("(max-width: 620px) and (prefers-reduced-motion: no-preference)").matches
) {
  let videoHasLoaded = false;
  const activationEvents = ["pointerdown", "touchstart", "wheel", "keydown"];

  const startHeroVideo = () => {
    if (videoHasLoaded) return;
    videoHasLoaded = true;

    activationEvents.forEach((eventName) => {
      window.removeEventListener(eventName, startHeroVideo);
    });

    heroMobileVideo.addEventListener(
      "canplay",
      () => heroMobileVideo.classList.add("is-ready"),
      { once: true },
    );
    heroMobileVideo.src = heroMobileVideo.dataset.src;
    heroMobileVideo.load();
    heroMobileVideo.play().catch(() => {
      videoHasLoaded = false;
    });
  };

  activationEvents.forEach((eventName) => {
    window.addEventListener(eventName, startHeroVideo, { passive: true });
  });
}

heroMobileVideo?.addEventListener(
  "play",
  () => publishAnalytics("hero_video_started", { placement: "hero_mobile" }),
  { once: true },
);

if (mobileBuy && heroActions && "IntersectionObserver" in window) {
  const mobileBuyObserver = new IntersectionObserver(
    ([entry]) => {
      const heroActionsHavePassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      mobileBuy.classList.toggle("is-visible", heroActionsHavePassed);
    },
    { threshold: 0.05 },
  );

  mobileBuyObserver.observe(heroActions);
} else {
  mobileBuy?.classList.add("is-visible");
}

function formatClp(amount) {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0,
  }).format(amount);
}

function formatInteger(value) {
  return new Intl.NumberFormat("es-CL", { maximumFractionDigits: 0 }).format(value);
}

function applyCommunityProgress(data) {
  if (!communityProgress) return;

  const followers = Number.parseInt(data.followers, 10);
  const goal = Number.parseInt(data.goal, 10);
  if (!Number.isInteger(followers) || !Number.isInteger(goal) || followers < 0 || goal < 1) return;

  const remaining = Math.max(0, goal - followers);
  const percent = Math.min(100, Math.max(0, (followers / goal) * 100));
  communityProgress.querySelector("[data-community-followers]").textContent = `${formatInteger(followers)} seguidores`;
  communityProgress.querySelector("[data-community-remaining]").textContent = formatInteger(remaining);
  communityProgress.querySelector("[data-community-percent]").textContent = `${percent.toLocaleString("es-CL", { maximumFractionDigits: 1 })}% de la meta`;

  const track = communityProgress.querySelector("[role='progressbar']");
  track.setAttribute("aria-valuenow", String(followers));
  track.setAttribute("aria-valuemax", String(goal));
  communityProgress.querySelector("[data-community-bar]").style.width = `${percent}%`;

  const updated = communityProgress.querySelector("[data-community-updated]");
  const updatedAt = Date.parse(data.updatedAt || "");
  if (Number.isFinite(updatedAt) && !data.stale) {
    const date = new Intl.DateTimeFormat("es-CL", { day: "numeric", month: "short" }).format(updatedAt);
    updated.textContent = `Actualizado automáticamente · ${date}`;
    communityProgress.classList.remove("is-stale");
  } else {
    updated.textContent = "Último dato verificado";
    communityProgress.classList.add("is-stale");
  }
}

if (communityProgress) {
  applyCommunityProgress({
    followers: communityProgress.dataset.fallbackFollowers,
    goal: communityProgress.dataset.goal,
    stale: true,
  });

  fetch(communityProgress.dataset.progressEndpoint, { headers: { Accept: "application/json" } })
    .then((response) => {
      if (!response.ok) throw new Error("No fue posible consultar el progreso.");
      return response.json();
    })
    .then(applyCommunityProgress)
    .catch(() => communityProgress.classList.add("is-stale"));
}

function setQuantity(nextQuantity, { track = false, method = "system" } = {}) {
  const previousQuantity = selectedQuantity;
  const quantity = normalizedQuantity(nextQuantity, MAX_QUANTITY);
  const pricing = pricingFor(quantity, shopifyPrices);
  selectedQuantity = quantity;
  quantityInput.value = String(quantity);
  quantityMinus.disabled = quantity === 1;
  quantityPlus.disabled = quantity === MAX_QUANTITY;

  cartSubtotal.textContent = formatClp(pricing.subtotal);
  cartDiscount.textContent = `−${formatClp(pricing.discount)}`;
  discountRow.classList.toggle("is-zero", pricing.discount === 0);
  cartTotal.textContent = formatClp(pricing.total);
  checkoutTotal.textContent = formatClp(pricing.total);
  cartComposition.textContent = compositionLabel(quantity, pricing);
  mobileName.textContent = `${quantity} ${quantity === 1 ? "oportunidad" : "oportunidades"}`;
  mobilePrice.textContent = formatClp(pricing.total);
  checkoutLabel.textContent = `Ir al pago con ${quantity} ${quantity === 1 ? "oportunidad" : "oportunidades"}`;

  opportunityOptions.forEach((option) => {
    const selected = Number.parseInt(option.dataset.opportunityQuantity, 10) === quantity;
    option.classList.toggle("is-selected", selected);
    option.setAttribute("aria-pressed", String(selected));
  });

  if (quantity < 8) {
    opportunityMessage.textContent = `Por ${formatClp(pricingFor(8, shopifyPrices).total - pricing.total)} más puedes llegar a 8 oportunidades.`;
  } else if (quantity === 8) {
    opportunityMessage.textContent = "Duplicaste tus oportunidades frente al pack inicial de 4.";
  } else if (quantity < 12) {
    opportunityMessage.textContent = `Por ${formatClp(pricingFor(12, shopifyPrices).total - pricing.total)} más puedes llegar a 12 oportunidades.`;
  } else {
    opportunityMessage.textContent = "Puedes comprar todos los packs que quieras. Cada sticker suma una oportunidad para ganar.";
  }

  if (track && quantity !== previousQuantity) {
    publishAnalytics("quantity_changed", {
      from_quantity: previousQuantity,
      to_quantity: quantity,
      quantity,
      method,
      value: pricing.total,
      currency: "CLP",
    });
  }
}

function selectPack(selectedCard) {
  cards.forEach((card) => {
    const selected = card === selectedCard;
    card.classList.toggle("is-selected", selected);
    card.querySelector(".pack-select").setAttribute("aria-pressed", String(selected));
  });

  const pack = packs[selectedCard.dataset.pack];
  publishAnalytics("pack_selected", {
    pack: selectedCard.dataset.pack,
    quantity: pack.quantity,
    value: analyticsValue(pack.quantity),
    currency: "CLP",
  });
  setQuantity(pack.quantity, { track: true, method: "pack_card" });
}

function openDrawer(source) {
  opener = source;
  setQuantity(selectedQuantity);
  drawer.setAttribute("aria-hidden", "false");
  document.body.classList.add("is-drawer-open");
  publishAnalytics("drawer_opened", {
    source: source?.dataset.analyticsSource || source?.dataset.analyticsCta || "unknown",
    quantity: selectedQuantity,
    value: analyticsValue(selectedQuantity),
    currency: "CLP",
  });
  window.requestAnimationFrame(() => drawerClose.focus());
}

function closeDrawer(method = "button") {
  drawer.setAttribute("aria-hidden", "true");
  document.body.classList.remove("is-drawer-open");
  publishAnalytics("drawer_closed", {
    method,
    quantity: selectedQuantity,
    value: analyticsValue(selectedQuantity),
    currency: "CLP",
  });
  opener?.focus();
}

cards.forEach((card) => {
  const button = card.querySelector(".pack-select");
  button.addEventListener("click", () => {
    selectPack(card);
    openDrawer(button);
  });
});

opportunityOptions.forEach((option) => {
  option.addEventListener("click", () => setQuantity(option.dataset.opportunityQuantity, { track: true, method: "preset" }));
});

document.querySelectorAll(".cart-open").forEach((button) => {
  button.addEventListener("click", () => openDrawer(button));
});

quantityMinus.addEventListener("click", () => setQuantity(selectedQuantity - 1, { track: true, method: "minus" }));
quantityPlus.addEventListener("click", () => setQuantity(selectedQuantity + 1, { track: true, method: "plus" }));
quantityInput.addEventListener("change", () => setQuantity(quantityInput.value, { track: true, method: "input" }));
quantityInput.addEventListener("blur", () => setQuantity(quantityInput.value));
drawerClose.addEventListener("click", () => closeDrawer("close_button"));
drawerBackdrop.addEventListener("click", () => closeDrawer("backdrop"));

document.querySelectorAll("[data-analytics-cta]").forEach((element) => {
  element.addEventListener("click", () => {
    publishAnalytics("cta_clicked", {
      placement: element.dataset.analyticsCta,
      destination: element.getAttribute("href") || "drawer",
    });
  });
});

document.querySelectorAll("[data-analytics-outbound]").forEach((element) => {
  element.addEventListener("click", () => {
    publishAnalytics("outbound_clicked", {
      target: element.dataset.analyticsOutbound,
      placement: element.dataset.analyticsCta || "unknown",
    });
  });
});

document.querySelectorAll("[data-analytics-faq]").forEach((details) => {
  details.addEventListener("toggle", () => {
    if (details.open) publishAnalytics("faq_opened", { question: details.dataset.analyticsFaq });
  });
});

if ("IntersectionObserver" in window) {
  const viewedSections = new Set();
  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const section = entry.target.dataset.analyticsSection;
        if (!entry.isIntersecting || viewedSections.has(section)) return;
        viewedSections.add(section);
        publishAnalytics("section_viewed", { section });
        sectionObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.12 },
  );

  document.querySelectorAll("[data-analytics-section]").forEach((section) => sectionObserver.observe(section));
}

checkoutButton.addEventListener("click", async () => {
  checkoutError.hidden = true;
  checkoutButton.disabled = true;
  checkoutButton.setAttribute("aria-busy", "true");
  let checkoutStage = "variant_validation";

  publishAnalytics("checkout_clicked", {
    quantity: selectedQuantity,
    value: analyticsValue(selectedQuantity),
    currency: "CLP",
  });

  try {
    if (!shopifyConfig.variantIds?.single || !shopifyConfig.variantIds?.four) {
      throw new Error("El producto no tiene configuradas las variantes 1 sticker y 4 stickers.");
    }

    const updates = shopifyCartUpdates(selectedQuantity, shopifyConfig.variantIds);
    const attributes = window.TellevoAttribution?.cartAttributes?.(activeAttribution) || {};
    const root = shopifyConfig.routesRoot || "/";

    checkoutStage = "cart_clear";
    const clearResponse = await fetch(root + "cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    });
    if (!clearResponse.ok) throw new Error("No fue posible preparar el carrito.");

    checkoutStage = "cart_update";
    const updateResponse = await fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates, attributes }),
    });
    if (!updateResponse.ok) throw new Error("No fue posible agregar los stickers al carrito.");

    checkoutStage = "total_validation";
    const cart = await updateResponse.json();
    const expectedTotal = pricingFor(selectedQuantity, shopifyPrices).total * 100;
    if (cart.total_price !== expectedTotal) {
      throw new Error("El total de Shopify no coincide con la selección. Inténtalo nuevamente.");
    }

    publishAnalytics("cart_prepared", {
      quantity: selectedQuantity,
      value: cart.total_price / 100,
      currency: cart.currency || "CLP",
    });
    checkoutStage = "redirect";
    window.location.assign(root + "checkout?locale=es");
  } catch (error) {
    publishAnalytics("cart_prepare_failed", {
      stage: checkoutStage,
      quantity: selectedQuantity,
      value: analyticsValue(selectedQuantity),
      currency: "CLP",
    });
    checkoutError.textContent = error.message || "No fue posible continuar al pago.";
    checkoutError.hidden = false;
    checkoutButton.disabled = false;
    checkoutButton.removeAttribute("aria-busy");
  }
});

window.addEventListener("pageshow", () => {
  checkoutButton.disabled = false;
  checkoutButton.removeAttribute("aria-busy");
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") {
    closeDrawer("escape_key");
  }

  if (event.key === "Tab" && drawer.getAttribute("aria-hidden") === "false") {
    const focusable = [...drawerPanel.querySelectorAll("button:not([disabled]), input:not([disabled])")];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
});

setQuantity(selectedQuantity);
